import { render, staticRenderFns } from "./ParticleBackground.vue?vue&type=template&id=058d49a8&scoped=true"
import script from "./ParticleBackground.vue?vue&type=script&lang=js"
export * from "./ParticleBackground.vue?vue&type=script&lang=js"
import style0 from "./ParticleBackground.vue?vue&type=style&index=0&id=058d49a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d49a8",
  null
  
)

export default component.exports